export default __webpack_public_path__ + "static/media/icon_eyes_close_20.87c46052.svg";